module.exports = __webpack_public_path__ + "media/images/emblems/Goeschenen-coat_of_arms-993b719faa13bc774a1742977d32b74f.svg";